import { useTheme, useMediaQuery } from "@mui/material";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import { Helmet } from "react-helmet";

import { Heading, SubHeading } from "@/auth/StyledComponents";
import { InternalLink, MakeOSIcon, PageTitle } from "@/common/CommonComponents";
import { SUPPORT_EMAIL } from "@/config";

export default function PaymentFailed() {
    const theme = useTheme();

    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    return (
        <>
            <Helmet>
                <PageTitle title="Payment Failed" />
            </Helmet>

            <Grid
                container
                direction="column"
                spacing={2}
                sx={{ marginTop: "36px", textAlign: "center" }}
            >
                <Grid item>
                    <Heading>Something went wrong</Heading>
                </Grid>
                <Grid item>
                    <SubHeading>
                        Sorry, we were unable to process your payment.
                    </SubHeading>
                </Grid>
                <Grid item>
                    <InternalLink href="/account">
                        <SubHeading>Please Try Again</SubHeading>
                    </InternalLink>
                </Grid>
                <Grid item>
                    <SubHeading>or</SubHeading>
                </Grid>
                <Grid item>
                    <Link href={`mailto:${SUPPORT_EMAIL}`} color="error">
                        <SubHeading>Contact Support</SubHeading>
                    </Link>
                </Grid>
            </Grid>
        </>
    );
}
